import ActivityIcon from './activityIcon'
import Modal from 'react-bootstrap/lib/Modal'
import PropTypes from 'prop-types'
import React, {Component, Fragment} from 'react'
import find from 'lodash/find'
import flatten from 'lodash/flatten'
import {css} from 'glamor'

import Input from './input'
import Button from './button'
import {activityOrderBySchoolType} from '../constants/activities'
import {colors, text} from '../styles'

const style = {
  activities: css({
    border: `1px solid ${colors.lightBorder}`,
    flex: '1 auto',
    fontSize: '12px',
    height: '600px',
    lineHeight: '21px',
    listStyle: 'none',
    margin: 0,
    overflowY: 'scroll',
    padding: 0,
    width: '50%',
    '&:first-child': {
      borderRight: 'none'
    }
  }),
  activitiesNested: css({
    background: colors.gray97
  }),
  activity: css({
    display: 'inline-block'
  }),
  activityActive: css({
    background: colors.gray89,
    fontWeight: 'bold'
  }),
  activityButton: css({
    background: colors.white,
    border: `1px solid ${colors.gray77}`,
    borderRadius: '3px',
    color: colors.white,
    height: '36px',
    margin: '0 4px 0 0',
    padding: 0,
    verticalAlign: 'middle',
    width: '36px',
    '&:focus': {
      outline: 'none'
    }
  }),
  activityButtonActive: css({
    border: `2px solid ${colors.primaryBG}`
  }),
  activityItem: css({
    borderBottom: `1px solid ${colors.lightBorder}`,
    '> button': {
      background: 'inherit',
      border: 'none',
      lineHeight: '40px',
      padding: '0 12px',
      textAlign: 'left',
      width: '100%',
      '&:focus': {
        outline: 'none'
      }
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  }),
  activityItemActive: css({
    background: colors.gray97,
    fontWeight: 'bold'
  }),
  activityItemButton: css({
    border: 'none',
    background: 'none',
    height: '100%',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    width: '100%',
    '&:focus': {
      outline: 'none'
    }
  }),
  activityList: css({
    borderBottom: `1px solid ${colors.lightBorder}`,
    listStyle: 'none',
    padding: '0 0 12px',
    margin: 0
  }),
  activitySelector: css({
    display: 'flex'
  }),
  modalCTA: css(text.bodySmallBold, {
    display: 'block',
    padding: '10px 0 0',
    textTransform: 'uppercase'
  }),
  modalHeader: css({
    border: 'none',
    padding: '15px 15px 0',
    textAlign: 'center'
  }),
  modalTitle: css({
    color: colors.grayMedium,
    fontSize: '14px',
    lineHeight: '16px',
    padding: '0 20px'
  }),
  modalActivity: css({
    margin: '4px 0 0',
    textTransform: 'none'
  }),
  viewAll: css({
    width: '97px !important'
  })
}

export default class ActivityList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hoverActivityGroup: null,
      hoverActivityTag: null,
      search: '',
      shouldDisplayActivityModal: false
    }
  }

  onSearch = (e) => {
    this.setState({search: e.target.value})
  }

  setActivity = (tag) => {
    this.setState(
      (state) => ({
        search: '',
        shouldDisplayActivityModal: !state.shouldDisplayActivityModal
      }),
      () => this.props.onChange(tag)
    )
  }

  setHoverActivityGroup = (group) => {
    this.setState({
      hoverActivityGroup: group
    })
  }

  onViewAll = () => {
    const {onViewAll} = this.props
    onViewAll
      ? onViewAll().then(this.toggleActivityModal)
      : this.toggleActivityModal()
  }

  toggleActivityModal = () => {
    this.setState((state, {activities, value}) => ({
      hoverActivityGroup: find(Object.keys(activities), (activityGroup) =>
        find(activities[activityGroup], {Tag: value.Tag})
      ),
      shouldDisplayActivityModal: !state.shouldDisplayActivityModal
    }))
  }

  renderActivity = (activity) => {
    const {value} = this.props
    let activityItemStyle = style.activityItem

    if (activity.Tag === value.Tag) {
      activityItemStyle = css(activityItemStyle, style.activityActive)
    }

    return (
      <li key={activity.Tag} {...activityItemStyle}>
        <button
          onClick={() => this.setActivity(activity.Tag)}
          {...style.activityItemButton}
        >
          {activity.Name}
        </button>
      </li>
    )
  }

  render() {
    const {activities, schoolType, speedDialActivities, onChange, value} =
      this.props
    const {hoverActivityGroup, search, shouldDisplayActivityModal} = this.state

    const searchResults = search
      ? flatten(Object.values(activities)).filter(
          (activity) =>
            activity.Name.toLowerCase().indexOf(search.toLowerCase()) > -1
        )
      : []

    const activityGroupOrder =
      activityOrderBySchoolType[schoolType] || activityOrderBySchoolType.default
    const activityList = activityGroupOrder
      .filter((activityGroupName) => activities[activityGroupName])
      .concat(
        Object.keys(activities).filter(
          (activityGroupName) => !activityGroupOrder.includes(activityGroupName)
        )
      )

    return (
      <Fragment>
        {activities && (
          <Modal
            show={shouldDisplayActivityModal}
            onHide={this.toggleActivityModal}
          >
            <Modal.Header closeButton {...style.modalHeader}>
              <div {...style.modalTitle}>Current Activity</div>
              <h4 {...style.modalActivity}>{value.Name}</h4>
              <span {...style.modalCTA}>Choose Activity</span>
            </Modal.Header>
            <Modal.Body>
              <Input
                icon="search"
                label="Search Activities"
                onChange={this.onSearch}
                size="block"
                value={search}
              />
              {searchResults.length ? (
                <ul {...style.activities}>
                  {searchResults.map(this.renderActivity)}
                </ul>
              ) : (
                <div {...style.activitySelector}>
                  <ul {...style.activities}>
                    {activityList.map((activityGroup) => {
                      let activityItemStyle = style.activityItem

                      if (activityGroup === hoverActivityGroup) {
                        activityItemStyle = css(
                          activityItemStyle,
                          style.activityItemActive
                        )
                      }

                      return (
                        <li key={activityGroup} {...activityItemStyle}>
                          <button
                            onClick={() =>
                              this.setHoverActivityGroup(activityGroup)
                            }
                          >
                            {activityGroup}
                          </button>
                        </li>
                      )
                    })}
                  </ul>
                  <ul {...style.activities} {...style.activitiesNested}>
                    {activities[hoverActivityGroup] &&
                      activities[hoverActivityGroup].map(this.renderActivity)}
                  </ul>
                </div>
              )}
            </Modal.Body>
          </Modal>
        )}
        <ul {...style.activityList}>
          {speedDialActivities.map((activity) => {
            let activityButtonStyle = style.activityButton

            if (activity.Tag === value.Tag) {
              activityButtonStyle = css(
                activityButtonStyle,
                style.activityButtonActive
              )
            }

            return (
              <li key={activity.Tag} {...style.activity}>
                <button
                  className="activityButton"
                  onClick={(e) => {
                    e.preventDefault()
                    onChange(activity.Tag)
                  }}
                  title={activity.Name}
                  {...activityButtonStyle}
                >
                  <ActivityIcon activity={activity} />
                </button>
              </li>
            )
          })}
          <li {...style.activity}>
            <Button
              kind="secondary"
              size="small"
              onClick={this.onViewAll}
              {...style.viewAll}
            >
              View all
            </Button>
          </li>
        </ul>
      </Fragment>
    )
  }
}

ActivityList.propTypes = {
  activities: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        Tag: PropTypes.string.isRequired,
        Name: PropTypes.string.isRequired
      })
    )
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onViewAll: PropTypes.func,
  schoolType: PropTypes.string.isRequired,
  speedDialActivities: PropTypes.arrayOf(
    PropTypes.shape({
      Tag: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    Tag: PropTypes.string.isRequired
  }).isRequired
}
